import React from "react";

const OfferingsSection = ({ heading, subHeading, offeringsList,image,
    ABOUT_SECTION_TITLE,ABOUT_SECTION_SUBTITLE,ABOUT_SECTION_DESC }) => {
  return (
    <div className="th-service__offerings">
      <div className="th-service__offerings__heading">
        <span
          style={{
            fontSize: "24px",
            color: "#383838",
            fontWeight: "700",
            lineHeight: "32px",
            fontStyle: "normal",
          }}
        >
          {heading}{" "}
          <span style={{ fontWeight: "400" }}>{subHeading}</span>
        </span>
      </div>

      {/* New Flex Container */}
      <div className="th-service__content">
        <div className="th-service__offering__container">
          {offeringsList.map((offering, index) => (
            <div className="th-service__offering__item" key={index}>
              <div className="th-service__offering__svg">{offering.icon}</div>
              <span className="th-service__offering__text">
                {offering.title}
              </span>
              <span className="th-service__offering__desc">
                {offering.description}
              </span>
            </div>
          ))}
        </div>

        {/* Image sits right */}
        {image && (
          <img src={image} className="th-works__image" alt="How does it work?" />
        )}
      </div>
      <div className="th-service__about">
        <div className="th-service__offerings__heading">
          <span
            style={{
              fontSize: "24px",
              color: "#383838",
              fontWeight: "700",
              lineHeight: "32px",
              fontStyle: "normal",
            }}
          >
            {ABOUT_SECTION_TITLE}{" "}
            <span
              style={{
                fontWeight: "400",
              }}
            >
              {ABOUT_SECTION_SUBTITLE}
            </span>
          </span>
        </div>
        <div className="th-footer__text">{ABOUT_SECTION_DESC}</div>
      </div>
    </div>
    
  );
};

export default OfferingsSection;
